import { render } from "./BoxIcon.vue?vue&type=template&id=6d93b098"
import script from "./BoxIcon.vue?vue&type=script&lang=js"
export * from "./BoxIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vdzeer/Projects/movesmart-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__